import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Main } from './Main';
import { Sandwich } from './Sandwich';
import {Aside} from './Aside';
import {BioForm} from './BioForm'

function App() {
  return (
    <body>
      <Sandwich />
      <Main />
      <Aside />
    </body>
  )
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
